import * as R from "ramda";
import { createSelector } from "reselect";
import { getters } from "./model";
import { getters as FormGetters } from "ui-kit/Form/model";
import {
  FIELDS_ID,
  FORM_INSTANCE_ID,
  SEARCH_BAR_INSTANCE_ID_CALENDAR_SECTION
} from "./constants";
import { isEmptyOrNil } from "utils/General";

import moment from "moment-timezone";

const DATE_FORMAT = "D MMM, ddd YYYY";

import { getters as SearchBarGetters } from "ui-kit/SearchBar";

export const getEventSelection = createSelector(
  state =>
    FormGetters.fields(state, {
      instanceId: FORM_INSTANCE_ID
    }),
  fields => {
    return R.path([FIELDS_ID.EVENT_FILTER, "value", 0, "id"], fields);
  }
);
export const getEventCheck = createSelector(
  state =>
    FormGetters.fields(state, {
      instanceId: FORM_INSTANCE_ID
    }),
  fields => {
    return R.path([FIELDS_ID.EVENTS, "value"], fields);
  }
);
export const getTaskCheck = createSelector(
  state =>
    FormGetters.fields(state, {
      instanceId: FORM_INSTANCE_ID
    }),
  fields => {
    return R.path([FIELDS_ID.TASKS, "value"], fields);
  }
);

export const getCalendarData = createSelector(
  getters.data,
  getters.selectedDate,
  getEventSelection,
  getEventCheck,
  getTaskCheck,
  (data, selectedDate, eventSelected, eventCheck, taskCheck) => {
    if (isEmptyOrNil(data) || isEmptyOrNil(eventSelected)) {
      return {};
    }
    const selectedDateFormatted = moment(selectedDate, DATE_FORMAT).startOf(
      "day"
    );

    const filteredEvents = Object.entries(data).reduce(
      (acc, [month, events]) => {
        const filtered = events
          .map(event => {
            const year = month.split(" ")[1];
            const [, monthName, day] = event.date.split(" ");
            const monthNameReplaced = R.replace(".", "", monthName);
            const eventDateWithYear = `${day} ${monthNameReplaced} ${year}`;
            const eventDate = moment(eventDateWithYear, DATE_FORMAT).startOf(
              "day"
            );

            const filteredEvents = event.events.filter(e => {
              const isWithinDateRange = eventDate.isSameOrAfter(
                selectedDateFormatted
              );
              // &&
              // eventDate.isSameOrBefore(
              //   moment(selectedDateFormatted).endOf("month")
              // );

              const isEventSelected =
                eventSelected === "all" ||
                (eventSelected !== "all" && e.eventId === eventSelected);

              const isEventTypeSelected =
                (eventCheck && e.type === "event") ||
                (taskCheck && e.type === "task") ||
                (!eventCheck && !taskCheck);

              return (
                isWithinDateRange && isEventSelected && isEventTypeSelected
              );
            });

            return filteredEvents.length > 0
              ? { ...event, events: filteredEvents }
              : null;
          })
          .filter(Boolean);

        if (filtered.length > 0) {
          acc[month] = filtered;
        }
        return acc;
      },
      {}
    );
    return filteredEvents;
  }
);

export const getMobileSearchCalendarData = createSelector(
  state =>
    SearchBarGetters.searchTerm(state, {
      instanceId: SEARCH_BAR_INSTANCE_ID_CALENDAR_SECTION
    }),
  getters.data,
  (searchTxt, data) => {
    if (isEmptyOrNil(data)) {
      return {};
    }
    if (isEmptyOrNil(searchTxt)) {
      return data;
    }
    let getSearchEvents = {};
    getSearchEvents = Object.entries(data).reduce((acc, [month, events]) => {
      const filtered = events
        .map(event => {
          const { events: eventsData = [] } = event;
          const filteredByName = R.filter(({ description }) =>
            description
              .toLowerCase()
              .includes(searchTxt ? searchTxt.toLowerCase() : "")
          )(eventsData);

          return filteredByName.length > 0
            ? { ...event, events: filteredByName }
            : null;
        })
        .filter(Boolean);

      if (filtered.length > 0) {
        acc[month] = filtered;
      }
      return acc;
    }, {});
    return getSearchEvents;
  }
);
